module.exports = __webpack_public_path__ + "static/media/hackathon_logo.92d75032.png";